import images from "../images";
import photocard_images from "./object-lists/photocard-images";
function Photocards(props) {

    const listPhotocards = props.shuffle(photocard_images);//take the first two in the shuffled array

    return (
    <div className='photocards'>
       <img id = "pearlheart1" src={images.pearlheart.url}></img>
        <img id = "pearlheart2" src={images.pearlheart.url}></img>
        <img id = "flower1" src={images.flower1.url}></img>
        <img id = "flower2" src={images.flower2.url}></img>
        <img id = "sando" src={images.sando.url}></img>
        <div className="photocard-container">
            <div className='hologif'></div>
            <div className='biasName'>{listPhotocards[0].title}</div>
            {/* <img className = "hologif" src={hologif}></img> */}
            <img className = 'photocard' src={listPhotocards[0].thumbnail} alt='chuu photocard'></img>
            
        </div>
        <div className="photocard-container">
            <div className='hologif'></div>
            <div className='biasName'>{listPhotocards[1].title}</div>
            <img className = 'photocard' src={listPhotocards[1].thumbnail} alt = 'choerry photocard'></img>
        </div>
      </div>
    );
  }

  export default Photocards;